// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	envName: 'gbull',
	stripePublicKey: 'pk_test_placeholder',
	bypassPayment: true,
	liveGatewayUrl: 'http://gbull-gbulll-W2SyIhkB5x8U-1472998774.us-west-2.elb.amazonaws.com',
};
